module.exports = __webpack_public_path__ + "img/download-btn.1fab2f7c.png";